import { LIST_USERS } from '../../../graphql/Query/users';
import { DISABLE_USER } from '../../../graphql/Mutation/users';
import { useMutation, useQuery } from '@apollo/client';
import CustomTable from '@myComponents/CustomTable';

import { handleConfirmCancel, handleError } from '@components/toast';
import { columns } from './columns';

import { useState } from 'react';
import Sidebar from './Sidebar';
import { useNavigate } from 'react-router-dom';
import { useDownloadCSV } from './hooks/useDownloadCSV';

const variables = {
  search: {
    q: '',
    page: 1,
    perPage: 10,
    status: 'EMPTY',
    membership: 'EMPTY',
    gender: 'EMPTY'
  }
};

const defaultValues = {
  fullName: '',
  email: '',
  phone: '',
  phonecode: '+57',
  gender: 'MALE',
  country: 'Colombia',
  membership: 'FREE',
  usedReferralCode: '',
  pin: '',
  status: 'ACTIVE'
};

const UsersList = () => {
  const { loading, data, refetch } = useQuery(LIST_USERS, {
    variables
  });
  const { handleDownload, loadingDownload } = useDownloadCSV();
  const navigate = useNavigate();
  const [handleDisable] = useMutation(DISABLE_USER);
  const [valuesForm, setValuesForm] = useState({});
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  const handleRedirect = ({ row }) => {
    const route = `/users/view/${row._id}`;
    navigate(route);
  };

  const handleUpdate = ({ row }) => {
    setValuesForm({
      ...row,
      phone: row?.phone
        ? row.phone.substring(row.phonecode.length, row.phone.length)
        : '',
      usedReferralCode: row?.usedReferralCode || ''
    });
    toggleSidebar();
  };

  const handleDelete = async ({ row }) => {
    handleConfirmCancel('delete', false, async () => {
      try {
        await handleDisable({ variables: { id: row._id } });
        refetch();
      } catch (e) {
        handleError(e);
        throw e;
      }
    });
  };

  return (
    <CustomTable
      loading={loading}
      store={data?.listUser?.docs || []}
      data={{ ...data?.listUser, docs: undefined }}
      refetch={refetch}
      headerOptions={{
        type: 'add',
        name: 'Crear Usuario',
        handle: () => {
          setValuesForm(defaultValues);
          toggleSidebar();
        }
      }}
      loadingDownload={loadingDownload}
      handleDownload={handleDownload}
      filterOptions={{
        types: [
          {
            id: 'admin_options',
            name: 'gender',
            options: 'genderOptions',
            type: 'select'
          },
          {
            id: 'admin_membership',
            name: 'membership',
            options: 'membershipOptions',
            type: 'select'
          },
          {
            id: 'admin_status',
            name: 'status',
            options: 'statusOptions',
            type: 'select'
          }
        ]
      }}
      variables={variables}
      columns={columns({ handleUpdate, handleRedirect, handleDelete })}
      sidebar={
        <Sidebar
          open={sidebarOpen}
          toggleSidebar={toggleSidebar}
          defaultValues={valuesForm}
          handleFetching={refetch}
        />
      }
    />
  );
};

export default UsersList;
